// extracted by mini-css-extract-plugin
module.exports = {"main":"LoadingScreen_main__412uj","mainTop":"LoadingScreen_mainTop__6n9Zr","loader":"LoadingScreen_loader__N7RHQ","spin":"LoadingScreen_spin__swEU6"};